import { render, staticRenderFns } from "./BtnLink.vue?vue&type=template&id=b20884d6&scoped=true&"
import script from "./BtnLink.vue?vue&type=script&lang=js&"
export * from "./BtnLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20884d6",
  null
  
)

export default component.exports